/**
 * Frequently Bought Together - Total price + Add to cart via AJAX
 */
(function () {
  const section = document.querySelector('.ob-fbt');
  if (!section) return;

  const totalEl = section.querySelector('[data-total-price]');
  const totalCompareEl = section.querySelector('[data-total-compare]');
  const savingsEl = section.querySelector('[data-savings]');
  const addBtn = section.querySelector('[data-add-btn]');
  const checkboxes = section.querySelectorAll('.ob-fbt__checkbox');

  function formatMoney(cents) {
    var format = window.obFbtMoneyFormat || '{{amount}}';
    var amount = cents / 100;
    var amountNoDecimals = Math.round(amount);
    var formatted = amountNoDecimals.toLocaleString('ar-EG');
    var formattedWithDecimals = amount.toLocaleString('ar-EG', { minimumFractionDigits: 2 });
    var str = String(format);
    if (str.indexOf('amount_no_decimals') !== -1) {
      str = str.replace(/\{\{amount_no_decimals\}\}/g, formatted);
      str = str.replace(/\{\{amount\}\}/g, formattedWithDecimals);
      return str;
    }
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    str = str.replace(/\{\{amount\}\}/g, formattedWithDecimals);
    return str;
  }

  function updateTotal() {
    let total = 0;
    let totalCompare = 0;
    let checkedCount = 0;

    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        total += parseInt(cb.dataset.price || '0', 10);
        totalCompare += parseInt(cb.dataset.comparePrice || cb.dataset.price || '0', 10);
        checkedCount++;
      }
    });

    if (totalEl) {
      totalEl.textContent = formatMoney(total);
      totalEl.classList.remove('visually-hidden');
    }
    if (totalCompareEl && totalCompare > total) {
      totalCompareEl.textContent = formatMoney(totalCompare);
      totalCompareEl.classList.remove('visually-hidden');
    } else if (totalCompareEl) {
      totalCompareEl.classList.add('visually-hidden');
    }
    if (savingsEl && totalCompare > total) {
      const savings = totalCompare - total;
      savingsEl.textContent = 'وفرتي ' + formatMoney(savings) + ' من السعر!';
      savingsEl.classList.remove('visually-hidden');
    } else if (savingsEl) {
      savingsEl.classList.add('visually-hidden');
    }

    if (addBtn) {
      addBtn.disabled = checkedCount === 0;
    }
  }

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', updateTotal);
  });

  updateTotal();

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;

      const items = [];
      checkboxes.forEach(function (cb) {
        if (cb.checked) {
          items.push({
            id: parseInt(cb.dataset.variantId, 10),
            quantity: 1
          });
        }
      });

      if (items.length === 0) return;

      addBtn.disabled = true;
      const originalText = addBtn.innerHTML;
      addBtn.innerHTML = '<span>جاري الإضافة...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status === 422) {
            throw new Error(data.description || data.message || 'Error');
          }
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ob-fbt', cartData: data });
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          addBtn.innerHTML = '<span>تمت الإضافة ✓</span>';
          setTimeout(function () {
            addBtn.innerHTML = originalText;
            addBtn.disabled = false;
          }, 2000);
        })
        .catch(function (err) {
          addBtn.innerHTML = originalText;
          addBtn.disabled = false;
          if (typeof console !== 'undefined' && console.error) {
            console.error('FBT add to cart error:', err);
          }
        });
    });
  }
})();
